import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import { API_URL } from "../../../../api";
import axios from "axios";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

function CommissionList() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [doctorLists, setDoctorLists] = useState([]);
  const [doctorID, setDoctorID] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [commissions, setCommissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filterDoctor, setFilterDoctor] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [selectedCommissions, setSelectedCommissions] = useState([]);
  const [totalSelectedAmount, setTotalSelectedAmount] = useState(0);
  const [collectDate, setCollectDate] = useState("");
  const [remark, setRemark] = useState("");

  const handleOpenDialog = () => setOpenDialog(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setShowDate(false);
  };

  const _export = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const exportData = commissions.map((row, index) => ({
    no: index + 1,
    voucherCode: row?.relatedTreatmentVoucher?.code || "N/A",
    patientName: row?.relatedTreatmentVoucher?.relatedPatient?.name || "N/A",
    doctorName: row?.relatedDoctor?.name || "N/A",
    voucherDate: row?.relatedTreatmentVoucher?.createdAt
      ? new Date(row.relatedTreatmentVoucher.createdAt).toLocaleDateString()
      : "N/A",

    treatmentName: row?.treatmentBreakdown[0]?.treatmentId?.name || "-",
    treatmentCount: row?.treatmentBreakdown?.length || 0,
    percent: row?.percent ? `${row.percent}%` : "0%",
    commissionAmount: row?.commissionAmount || 0,
    appointmentAmount: row?.appointmentAmount || 0,
    status: row?.status || "Unpaid",
    createdAt: row?.createdAt
      ? new Date(row.createdAt).toLocaleDateString()
      : "N/A",
  }));

  useEffect(() => {
    const getDoctorLists = async () => {
      const res = await api.get("doctors");

      setDoctorLists(res.data.data);
      setDoctorID("");
    };

    getDoctorLists();
  }, []);

  const toISODate = (date, isEnd = false) => {
    if (!date) return "";

    const d = new Date(date);

    if (isEnd) {
      d.setHours(23, 59, 59, 999);
    } else {
      d.setHours(0, 0, 0, 0);
    }

    return d.toISOString();
  };

  const getCommission = async () => {
    let query = `commissions?page=${page + 1}&limit=${rowsPerPage}`;

    if (filterDoctor) {
      query += `&relatedDoctor=${filterDoctor}`;
    }

    if (filterStartDate) {
      query += `&startDate=${toISODate(filterStartDate)}`;
    }

    if (filterEndDate) {
      query += `&endDate=${toISODate(filterEndDate, true)}`;
    }

    query += `&status=Unpaid`;

    const res = await api.get(query);

    setCommissions(res.data.data);
    setTotalCount(res.data._metadata.total);
  };

  useEffect(() => {
    getCommission();
  }, [page, rowsPerPage, filterDoctor, filterStartDate, filterEndDate]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const navigate = useNavigate();

  const handleCollect = async () => {
    if (selectedCommissions.length === 0) {
      alert("Please select at least one commission.");
      return;
    }

    const payload = {
      commissionIds: selectedCommissions,
      previousCommissionAmount: totalSelectedAmount,
      collectDate,
      remark,
    };

    try {
      const res = await api.post("commissions-pay", payload);
      navigate("/paid-commission");

      setSelectedCommissions([]);
      setTotalSelectedAmount(0);
      setCollectDate("");
      setRemark("");
      handleCloseDialog();
      getCommission();
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };
  return (
    <Box p={2}>
      <h4 className="fs-5 py-3">Commission List</h4>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={3}>
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 600,
              mb: 0.5,
              color: "gray",
            }}
          >
            Name
          </Typography>
          <TextField
            fullWidth
            size="small"
            select
            value={doctorID}
            onChange={(e) => {
              const selectedDoctor = e.target.value;
              setDoctorID(selectedDoctor);
              setFilterDoctor(selectedDoctor);
              setPage(0);
            }}
          >
            <MenuItem value="">All</MenuItem>
            {doctorLists?.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 600,
              mb: 0.5,
              color: "gray",
            }}
          >
            Start Date
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 600,
              mb: 0.5,
              color: "gray",
            }}
          >
            End Date
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} md={5} textAlign="right">
          <Button
            variant="contained"
            sx={{ mr: 1, backgroundColor: "#1565C0" }}
            onClick={() => {
              setDoctorID("");
              setStartDate("");
              setEndDate("");

              setFilterDoctor("");
              setFilterStartDate("");
              setFilterEndDate("");

              setPage(0);
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={{ mr: 1, backgroundColor: "#1565C0" }}
            onClick={() => {
              setFilterDoctor(doctorID);
              setFilterStartDate(startDate);
              setFilterEndDate(endDate);
              setPage(0);
            }}
          >
            Filter
          </Button>
          <Button
            variant="contained"
            sx={{ mr: 1, backgroundColor: "#1565C0" }}
            onClick={excelExport}
          >
            Export
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#34A853" }}
            onClick={handleOpenDialog}
          >
            Paid
          </Button>
        </Grid>
      </Grid>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{doctorID ? "Doctor's Commissions" : "Commissions"}</span>

          <Link to="/paid-commission" className="btn btn-sm btn-success">
            Paid Commission
          </Link>
        </DialogTitle>

        <DialogContent dividers>
          <div className="row">
            <div className="col-6">
              <h5 className="fs-5">
                {doctorID ? doctorID + "'s Commissions" : ""}
              </h5>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-4">
              <label>Previous Collect Amount</label>
              <input
                type="number"
                className="form-control"
                value={totalSelectedAmount}
                readOnly
              />
            </div>

            <div className="col-4">
              <label>Collect Date</label>
              <input
                type="date"
                className="form-control"
                value={collectDate}
                onChange={(e) => setCollectDate(e.target.value)}
              />
            </div>

            <div className="col-4">
              <label>Remark</label>
              <input
                type="text"
                className="form-control"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} color="error">
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleCollect}>
            Collect
          </Button>
        </DialogActions>
      </Dialog>
      <ExcelExport data={exportData} ref={_export}>
        <ExcelExportColumn field="no" title="#" width={50} />
        <ExcelExportColumn field="voucherCode" title="Voucher Code" />
        <ExcelExportColumn field="patientName" title="Patient Name" />
        <ExcelExportColumn field="doctorName" title="Doctor Name" />
        <ExcelExportColumn field="voucherDate" title="Voucher Date" />
        <ExcelExportColumn field="treatmentName" title="Treatment Name" />
        <ExcelExportColumn field="treatmentCount" title="Treatment Count" />
        <ExcelExportColumn field="percent" title="Percent (%)" />
        <ExcelExportColumn field="commissionAmount" title="Commission Amount" />
        <ExcelExportColumn
          field="appointmentAmount"
          title="Appointment Amount"
        />
        <ExcelExportColumn field="status" title="Status" />
        <ExcelExportColumn field="createdAt" title="Created At" />
      </ExcelExport>
      <Paper sx={{ p: 2, mt: 2, borderRadius: 2 }}>
        <div className="row">
          <div class="col-md-12 card px-3 py-3">
            <div class="table-responsive text-black" id="slimtest2">
              <TableContainer
                component={Paper}
                sx={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Voucher Code
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Patient Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Doctor Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Voucher Date
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Treatment Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Treatment Count
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Percent (%)
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Commission Amount
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Appointment Amount
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "black",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Created At
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {commissions.map((row, index) => (
                      <TableRow key={row._id}>
                        <TableCell padding="checkbox">
                          <TableCell padding="checkbox">
                            <Checkbox
                              size="small"
                              checked={selectedCommissions.includes(row._id)}
                              onChange={(e) => {
                                let updatedSelection = [];
                                if (e.target.checked) {
                                  updatedSelection = [
                                    ...selectedCommissions,
                                    row._id,
                                  ];
                                } else {
                                  updatedSelection = selectedCommissions.filter(
                                    (id) => id !== row._id,
                                  );
                                }
                                setSelectedCommissions(updatedSelection);

                                const total = commissions
                                  .filter((c) =>
                                    updatedSelection.includes(c._id),
                                  )
                                  .reduce(
                                    (sum, c) => sum + (c.commissionAmount || 0),
                                    0,
                                  );
                                setTotalSelectedAmount(total);
                              }}
                            />
                          </TableCell>
                        </TableCell>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          {row?.relatedTreatmentVoucher?.code || "N/A"}
                        </TableCell>
                        <TableCell>
                          {row?.relatedTreatmentVoucher?.relatedPatient?.name}
                        </TableCell>
                        <TableCell>
                          {row?.relatedDoctor?.name || "N/A"}
                        </TableCell>
                        <TableCell>
                          {row?.relatedTreatmentVoucher?.createdAt
                            ? new Date(
                                row.relatedTreatmentVoucher.createdAt,
                              ).toLocaleDateString()
                            : "N/A"}
                        </TableCell>
                        <TableCell>
                          {row?.treatmentBreakdown[0]?.treatmentId?.name || "-"}
                        </TableCell>
                        <TableCell>
                          {row?.treatmentBreakdown?.length || 0}
                        </TableCell>
                        <TableCell>{row?.percent + "%"}</TableCell>
                        <TableCell>
                          {row?.commissionAmount?.toLocaleString() || "0"}
                        </TableCell>
                        <TableCell>
                          {row?.appointmentAmount?.toLocaleString() || "0"}
                        </TableCell>

                        {/* Status */}
                        <TableCell>{row?.status || "Unpaid"}</TableCell>

                        {/* Created Date */}
                        <TableCell>
                          {row?.createdAt
                            ? new Date(row.createdAt).toLocaleDateString()
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",

                  "& .MuiTablePagination-toolbar": {
                    display: "flex",
                    alignItems: "center",
                    minHeight: "52px",
                  },

                  "& .MuiTablePagination-selectLabel": {
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  },

                  "& .MuiTablePagination-displayedRows": {
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  },

                  "& .MuiTablePagination-actions": {
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              />
            </div>
          </div>
        </div>
      </Paper>
    </Box>
  );
}

export default CommissionList;
